// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__ViYjd","ThankYou":"Footer_ThankYou__3hijI","Leaf":"Footer_Leaf__1vMAu"};